import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import QueueInputs from './components/QueueInputs';

import { accessLocalStorage, exportCreateQueues, valuesAnalyze, changeViewForms, readAllTenant, getMusicOnHoldData } from '../../../services';

import '../../../libs/bulma.min.css';
import './QueuesForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faUsers } from '@fortawesome/free-solid-svg-icons';

function QueuesCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    autofill: 'yes',
    queueEntryVarQueue: 'yes',
    timeout: null,
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [moh, setMoh] = useState([]);
  const [disableTimeout, setDisableTimeout] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    {
      name, string
      music, string
      strategy, string
      autofill, string (yes/no) zzz
      maxlen, number
      ringinuse, string (yes/no)
      announcePosition, string (yes/no)
      announceFrequency, number
      announceHoldTime, string (yes/no)
      minAnnounceFrequency, number
      queueEntryVarQueue, string (yes/no)
      wrapuptime, number
      joinempty, string (yes/no/strict)
      leavewhenempty string (yes/no/strict)
      accountcode
    }
  */

  const fetchMusicOnHold = async () => {
    const response = await getMusicOnHoldData();
    return response.data;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!idtenant.includes('vgs')) fetchTenants = fetchTenants.filter((tenant) => idtenant.includes(tenant.short_name));
    let fetchMoh = await fetchMusicOnHold();
    if (!idtenant.includes('vgs')) fetchMoh = fetchMoh.filter((moh) => idtenant.includes(moh.accountcode));
    setTenants(fetchTenants);
    setMoh(fetchMoh);
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar, isNumberNoZero } = valuesAnalyze;

    if(name === 'maxlen' || name === 'announceFrequency' || name === 'minAnnounceFrequency' || name === 'wrapuptime') {
      const checkValueIsNumber = value < 1 ? false : checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    const isNameValue = name === 'name' ? value.toLowerCase() : value;
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = isNameValue )
    if(Object.keys(validate).length >= 12) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    if(name === 'strategy') {
      value === 'linear' ? setDisableTimeout(false) : setDisableTimeout(true);
    };
    return;
  };

  const sendDataQueueGenerate = async () => {
    const fetchQueues = await exportCreateQueues(values);
    const result = Object.keys(fetchQueues).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-create-queues');
      setTimeout(() => {
        window.location.reload(true);
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="queues-form-container">
      <div className="queues-form-header">
        <div className="queues-form-title-wrapper">
          <svg className="queues-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <div>
            <h1 className="queues-form-title">Adicionar Fila</h1>
            <p className="queues-form-subtitle">Crie um novo grupo atendedor</p>
          </div>
        </div>
      </div>

      <div className="alerts-section">
        <div id="success-create-queues" className="alert-message alert-success is-hidden">
          <div className="alert-header">
            <span>Sucesso!</span>
            <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-create-queues')}>×</button>
          </div>
          <div className="alert-body">
            Fila criada com <strong>sucesso</strong>!
          </div>
        </div>
      </div>

      <div className="form-card">
        <QueueInputs
          changeValues={handleChangeValues}
          tenants={tenants}
          moh={moh}
          disableTimeout={disableTimeout}
        />

        <div className="form-actions">
          <button className="btn-submit" type="submit" disabled={disable} onClick={() => sendDataQueueGenerate()}>
            <FontAwesomeIcon icon={faPhoneSquare} />
            <span>Criar Grupo Atendedor</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default QueuesCreate;
